import {
  getSiteCurrencyISO,
  SiteCurrency,
  SiteLanguage,
} from '../data/models/locale'
import { store } from '../store/store'

export function formatMoney(val: number) {
  const state = store.getState()
  const currency = getSiteCurrencyISO(
    state.locale.currency || SiteCurrency.euro,
  )

  return val.toLocaleString(
    (state.locale.language || SiteLanguage.en).toString(),
    { currency, style: 'currency' },
  )
}
